import React, {Component} from 'react';

class RenderDocumentFooter extends Component {
    render() {
        return (
            <div>
                footer
            </div>
        );
    }
}

export default RenderDocumentFooter;